import React, { Component } from 'react';

import InputSelect from '../../common/InputSelect/InputSelect';
import TableHeader from './TableHeader';
import TableRows from './TableRows';

import StyledStatsTable from './styles/StyledStatsTable';
import StyledStats from './styles/StyledStats';


class StatsView extends Component {
  componentDidMount() {
    const { 
      modalData,
      getOfficesDD, getStats,
    } = this.props;

    getOfficesDD();
    if (modalData.defaultOffice !== null) {
      getStats(modalData.defaultOffice)
    }
  }

  render() {
    const { 
      modalData, statsData, officesDDData,
      handleSelectOffice,
    } = this.props;
    return (
      <StyledStats>
        <StyledStatsTable>

          <div className="stats-view--header">
            Statistiky
          </div>

          <div className="stats-view--input">
            <div className="stats-view--input-label">
              Pobočka
            </div>
            <InputSelect
              options={officesDDData.data}
              onChange={(selected) => handleSelectOffice(selected)}
              value={modalData.selectedOffice}
              getOptionValue={(option) => option.id}
              getOptionLabel={(option) => option.name}
              isLoading={officesDDData.isLoading}
              placeholder="Zvolte pobočku"
              noOptionsMessage={() => 'Žádné pobočky'}
              loadingMessage={() => 'Načítám'}
            />
          </div>
          
          <TableHeader />
          <TableRows statsData={statsData} />

        </StyledStatsTable>
      </StyledStats>
    );
  }
}

export default StatsView;



// WEBPACK FOOTER //
// ./src/components/Stats/StatsView.js